import type { FaireProductEntity } from "../../entity_types/product";

export const p_2p98hr6ktw: FaireProductEntity = {
  token: "p_2p98hr6ktw",
  type: "product",
  name: "Wild Watermelon Power Mist Hydrating Hand Sanitizer",
  brandToken: "b_evrq835k7x",
  brandName: "Touchland",
  imageUrl:
    "https://cdn.faire.com/fastly/f2c4eb758070d9eb329e3a6b13a94c4886d34713aac7e31480726f62bfc6d6ae.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/37ed550c5164500b4a789ea96a7693eb8de209e6740e5cddb7ce2d97b6b05fac.jpeg",
    "https://cdn.faire.com/fastly/15a78cc90e7ec9b7b74862ab730bdbdf319504a3c80baacaf5eaa4b7ddbe7a5f.jpeg",
    "https://cdn.faire.com/fastly/4bdb2fc67c81d814233ffc76ca8da8edd322b5fadf347d9ed29a7d2afbfc78e4.jpeg",
    "https://cdn.faire.com/fastly/e6279e025829dbd7fa0301ebd7ab86bba4e76bbc3d4cef4c6f90a6c12f4b0d4f.jpeg",
    "https://cdn.faire.com/fastly/f2a16c923e0a4e025c8ab77e7d6056dfde96224e7efe6aa897fc2c46cfee044f.jpeg",
  ],
  priceDollars: 5,
  description:
    "A skincare-forward hand sanitizer that leaves hands sanitized, hydrated, and delicately scented.\n\nWild Watermelon Scent: Juicy and playful. Wild watermelon mingles with jasmine petals and the soft sweetness of fuzzy peaches, evoking a carefree summer breeze and sunlit joy.\n\nTOP NOTES: Fresh Watermelon, Tart Kiwi. \nHEART NOTES: Jasmine Petals, Watery Violet, Crisp Apple.\nBASE NOTES: Fuzzy Peaches, Clean Musks, Wild Greens. \n\nMAIN INGREDIENTS: \n- Alcohol: Effective against most common bacteria. \n- Aloe Vera: Helps hydrate skin and leaves a non-greasy finish. \n- Radish Root Ferment Filtrate: Helps enhance skin’s moisture retention.\n\nBENEFITS:\n- Hydrating - Enriched with Aloe Vera to help hydrate skin.\n- Uplifting scent - Available in 15+ scents.\n- Lightweight - Non-sticky and fast-absorbing formula delivered in a micro-mist. \n- Free from phthalates and sulfates.\n- Vegan and cruelty-free.\n- Dermatologically tested.\n- Travel-friendly 1 FL. OZ. (30 mL).",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-17T18:38:49.133Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
